import Flex from "@irati/ui/src/Flex"
import styled, {css} from "styled-components"

export const CashbackRedemptionWrapper = styled(Flex)`
  ${({theme}) => css`
    gap: 0;
    flex-direction: column;
    ${theme.mediaQueries.minWidthMedia.tablet`
      flex-direction: row;
      gap: ${theme.spacing.three};
    `}
  `}
`

export const TicketWrapper = styled.div`
  flex: 1 1 60%;
`

export const RedemptionInstructionsWrapper = styled(Flex)`
  ${({theme}) => css`
    margin: 0;
    ${theme.mediaQueries.minWidthMedia.tablet`
      z-index: 1;
      margin: 120px 0 30px 0;
      flex: 1 1 40%;
    `}
  `}
`

export const IconWrapper = styled.div`
  flex-shrink: 0;
  width: 48px;
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
`
